import React from "react";
import { clientsList } from "../data/clientsData";

const Client = () => {
  return (
    <section id="clients" className="bg-slate-950 pt-32 pb-28 text-slate-100 relative overflow-hidden bg-cyber-grid border-t border-b border-emerald-500/20">
      <div className="container mx-auto px-4">
        <div className="w-full">
          <div className="mx-auto mb-16 text-center max-w-xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-mono text-xs font-bold uppercase tracking-widest mb-4">
              💻 ENTERPRISE &amp; TECH ECOSYSTEMS
            </div>
            <h2 className="mb-4 text-3xl font-black text-white sm:text-4xl lg:text-5xl tracking-tight">
              Enterprise Ecosystems &amp; <span className="text-emerald-400">Tech Platforms</span>
            </h2>
            <p className="text-sm font-normal text-slate-400 leading-relaxed">
              Architecting high-availability software systems, microservices, and web portals that scale across enterprise state-owned corporations &amp; FinTech ecosystems.
            </p>
          </div>
        </div>

        <div className="w-full">
          <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-8">
            {clientsList.map((client) => (
              <a
                key={client.id}
                href={client.link}
                target="_blank"
                rel="noopener noreferrer"
                className="cyber-card group p-6 rounded-3xl border border-emerald-500/20 bg-slate-900/80 backdrop-blur-md flex items-center justify-center max-w-[200px] w-full transition-all duration-300 hover:scale-110 hover:border-emerald-400 shadow-xl"
              >
                <img
                  src={client.image}
                  alt={client.name}
                  className="max-h-12 object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Client;
